import React, { Component } from 'react'
import { TxPage } from '../../../components'

class TransactionListPage extends Component {
    render() {
        return <TxPage {...this.props} />
    }
}
export default TransactionListPage
